import React, { useState } from 'react';
import { Plane, Lock, User, ArrowRight, Building } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function InviteAcceptPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('/login');
    }, 1500);
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-1599">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-1600"></div>

      <div className="relative w-full max-w-md p-6" data-id="element-1601">
        <div className="mb-8 text-center" data-id="element-1602">
          <div className="mx-auto mb-4 flex h-16 w-auto items-center justify-center" data-id="element-1603">
            <img src="https://cdn.magicpatterns.com/uploads/76CAA7KBYMWEPu97mZSYz3/Untitled_design.png" alt="Super International Travels Limited" className="h-full w-auto max-w-[240px] object-contain" data-id="element-1604" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-1605">Join Acme Corp</h1>
          <p className="mt-2 text-slate-400" data-id="element-1606">
            You've been invited to join Super International Travels
          </p>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-2xl" data-id="element-1607">
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1608">
            <div data-id="element-1609">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1610">
                Organization
              </label>
              <div className="relative" data-id="element-1611">
                <Building className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1612" />
                <input type="text" disabled value="Acme Corp" className="block w-full rounded-lg border border-slate-200 bg-slate-50 pl-10 p-2.5 text-slate-500" data-id="element-1613" />
              </div>
            </div>

            <div data-id="element-1614">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1615">
                Email Address
              </label>
              <input type="email" disabled value="sarah.connor@acme.com" className="block w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-slate-500" data-id="element-1616" />
            </div>

            <div data-id="element-1617">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1618">
                Full Name
              </label>
              <div className="relative" data-id="element-1619">
                <User className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1620" />
                <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="Sarah Connor" data-id="element-1621" />
              </div>
            </div>

            <div data-id="element-1622">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1623">
                Department
              </label>
              <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1624">
                <option data-id="element-1625">Engineering</option>
                <option data-id="element-1626">Sales</option>
                <option data-id="element-1627">Marketing</option>
                <option data-id="element-1628">Operations</option>
                <option data-id="element-1629">HR</option>
              </select>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-1630">
              <div data-id="element-1631">
                <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1632">
                  Password
                </label>
                <div className="relative" data-id="element-1633">
                  <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-1634" />
                  <input type="password" required className="block w-full rounded-lg border border-slate-300 pl-9 p-2.5 text-sm focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-1635" />
                </div>
              </div>
              <div data-id="element-1636">
                <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-1637">
                  Confirm
                </label>
                <div className="relative" data-id="element-1638">
                  <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-1639" />
                  <input type="password" required className="block w-full rounded-lg border border-slate-300 pl-9 p-2.5 text-sm focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-1640" />
                </div>
              </div>
            </div>

            <button type="submit" disabled={isLoading} className="flex w-full items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 disabled:opacity-70" data-id="element-1641">
              {isLoading ? 'Setting up account...' : 'Accept Invitation'}
              {!isLoading && <ArrowRight className="ml-2 h-4 w-4" data-id="element-1642" />}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-slate-500" data-id="element-1643">
          Not you?{' '}
          <Link to="/login" className="font-medium text-blue-400 hover:underline" data-id="element-1644">
            Sign in to a different account
          </Link>
        </p>
      </div>
    </div>;
}